import { axios } from '../utils/request_new'

/* 查询推送记录 */
export function getDeviceRecord(data = { sn: '', page: 1, pagesize: 99999 }) {
  return axios({
    url: '/print/device-push-records/page',
    method: 'GET',
    params: data
  })
}

// 删除设备推送记录
// sn 为必填，标识设备；若提供 id 则删除该设备的单条记录，否则删除该设备的全部记录。
export function delDeviceRecord (params = { sn: '', id: '' }) {
  return axios({
    url: '/print/device-push-records',
    method: 'delete',
    params
  })
}

// 查询推送执行进度
export function getPublishTrace(traceId) {
  return axios({
    url: `/print/vision-templates/publish-logs/trace/${traceId}`,
    method: 'GET'
  })
}

export default {
  getDeviceRecord,
  delDeviceRecord,
  getPublishTrace
}